import { render, staticRenderFns } from "./tiscOption.vue?vue&type=template&id=b2dd7ada&scoped=true&"
import script from "./tiscOption.vue?vue&type=script&lang=js&"
export * from "./tiscOption.vue?vue&type=script&lang=js&"
import style0 from "./tiscOption.vue?vue&type=style&index=0&id=b2dd7ada&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2dd7ada",
  null
  
)

export default component.exports